export const FILTER_PARAMS_HOSTS = 'host_ids'
export const FILTER_PARAMS_OWNERS = 'owner_ids'
export const FILTER_PARAMS_USERS = 'permitted_user_ids'
export const FILTER_PARAMS_PERMISSION = 'permission'
